module.exports = __webpack_public_path__ + "media/common/img/hand_on_hip_robot-2307e00bbb4fb4ff76084a1d02a9d4b3.svg";